// extracted by mini-css-extract-plugin
export default {"section":"FAQ_section__jqEQq","container":"FAQ_container__IRZz5","question":"FAQ_question__t3UEk","active":"FAQ_active__5QS5r","answer":"FAQ_answer__smavQ"};